import { z } from "zod";

// 9-value category set
// ZWROT (refund) added on top of the original 8-value set (feature 003-classify-outgoing-transactions).
export const CostCategorySchema = z.enum([
  "KOSZT_STAŁY",
  "KOSZT_BIEŻĄCY",
  "WYNAGRODZENIE",
  "SKŁADKI_ZUS",
  "PODATEK_PIT4",
  "PODATEK_CIT",
  "ZWROT",
  "IGNORUJ",
  "DO_WERYFIKACJI",
]);
export type CostCategory = z.infer<typeof CostCategorySchema>;

export const CostEntrySchema = z.object({
  id: z.string().uuid(),
  transaction_date: z.string().date(),
  invoice_date: z.string().date().nullable(),
  company_name: z.string(),
  gross_amount: z.string().regex(/^\d+\.\d{2}$/),
  net_amount: z.string().regex(/^\d+\.\d{2}$/),
  vat_amount: z.string().regex(/^\d+\.\d{2}$/),
  category: CostCategorySchema,
  employee_name: z.string().nullable(),
  is_deductible: z.boolean(),
  transfer_title: z.string(),
  cost_name: z.string().nullable(),
  default_vat_rate: z.string().nullable(),
  invoice_id: z.string().uuid().nullable().optional(),
});
export type CostEntry = z.infer<typeof CostEntrySchema>;

export const CostTotalsSchema = z.object({
  gross: z.string().regex(/^\d+\.\d{2}$/),
  net: z.string().regex(/^\d+\.\d{2}$/),
  vat: z.string().regex(/^\d+\.\d{2}$/),
  deductible_net: z.string().regex(/^\d+\.\d{2}$/),
});
export type CostTotals = z.infer<typeof CostTotalsSchema>;

export const CostListResponseSchema = z.object({
  costs: z.array(CostEntrySchema),
  total: z.number().int().min(0),
  totals: CostTotalsSchema,
});
export type CostListResponse = z.infer<typeof CostListResponseSchema>;

export const CostListQuerySchema = z
  .object({
    category: CostCategorySchema.optional(),
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    search: z.string().max(200).optional(),
    deductible_only: z
      .string()
      .optional()
      .transform((v) => v === "true"),
  })
  .refine((d) => !d.from || !d.to || d.from <= d.to, {
    message: "`from` must be <= `to`",
  });
export type CostListQuery = z.infer<typeof CostListQuerySchema>;
